// How the signed-in user's name is displayed — always from the server-
// confirmed profile (hooks/useProfile), never from browser storage or a
// placeholder. Missing name → empty string, so callers show nothing rather
// than an invented identity.

/** Full name in the UI language (Arabic name first in Arabic, and vice versa). */
export const getProfileDisplayName = (profile, language) => {
  const name =
    language === "ar"
      ? profile?.employeeArabicName || profile?.employeeName
      : profile?.employeeName || profile?.employeeArabicName;
  return name ? String(name).trim() : "";
};

/** First word of the display name (greetings). */
export const getProfileFirstName = (profile, language) =>
  getProfileDisplayName(profile, language).split(/\s+/)[0] || "";
